import estyled from '@signal/theme/emotion'

export const Wrapper = estyled.div`
  position: relative;
`
